import React, { Component } from "react";
import _, {capitalize, isEmpty, lowerCase} from "lodash";
import { CellRenderers } from "utils/tableUtils";
import TableContainerEvolved from "components/TableContainerEvolved";
import { Card, Typography, Select, Tooltip} from "antd";
import BuildAPI from "restAPI/BuildAPI";
import ModalUtil from "utils/modalUtil";
import Vocabulary from 'components/Vocabulary';
import ReleasePopup from './ReleasePopup';
import { withRouter } from 'react-router-dom';
import message from "components/CustomMessage";
import moment from "moment";
import { CAPITALIZED_SEVERITIES, SEVERITY_NAMES } from "views/Findings/Constants";
import { hasPermission } from "utils/authService";
import { PermissionSetMap } from "constants/RBACConstants";
import { InfoIcon } from "components/Icons";
import { displayRiskRatingCountWithTooltip } from "utils/riskScoreUtil";
import { RISK_SCORE_RATINGS } from "constants/RiskScoreConstants";
import { updateURLSearch } from "utils/urlUtil";
import ACFindingSeverityBreakDownBar from "ac-components/ACFindingSeverityBreakDownBar/ACFindingSeverityBreakDownBar";
import { FINDING_SEVERITY_BREAKDOWN_WIDTH } from "constants/Layout";

const {Text} = Typography;
class JenkinsListing extends Component{
    constructor(props){
        super(props);
        this.state = {
            buildData: null,
            selectedRowKeys:[]
        }
        _.bindAll(
            this,
            "refreshTable",
            "findingsRedirect"
        )
    }

    refreshTable() {
        if(this.tableRef) {
            this.tableRef.refresh();
        }
    }

    findingsRedirect(severity, findingsId, isRiskScoreBasedReleaseProcess) {
        const ids = isRiskScoreBasedReleaseProcess ? findingsId?.[RISK_SCORE_RATINGS[severity.replace(" ", "_")]] : findingsId?.[SEVERITY_NAMES[severity]];
        if(_.isEmpty(ids)){
            return;
        }
        const filters = {
            id: ids
        }

        updateURLSearch(this.props.history, {filters, pagination: { page: 0 }}, "/findings");
    }

    getCoulmns() {
        const columns = [{
            title:"Build #",
            width: 60,
            dataIndex: "buildNumber",
            showFilter: true,
            onlySearch: true
        },{
            title: <Vocabulary name="product" />,
            dataIndex: "product",
            showFilter: true,
            render: (text) => <Text>{text && text.name ? text.name : "--"}</Text>,
            optional: true,
            width: 80,
            default: true
        },{
            title: <Vocabulary name="subProduct" />,
            dataIndex: "subproduct",
            showFilter: true,
            render: (text) => <Text>{text && text.name ? text.name : "--"}</Text>,
            optional: true,
            width: 100,
            default: true
        },{
            title:"Environment",
            dataIndex: "env",
            showFilter: true,
            width: 100,
            optional: true,
            default: true
        },
        {
            title:"Build Tool",
            dataIndex: "buildTool",
            showFilter: true,
            render: (tool) => toolName[tool] || capitalize(tool),
            filterLabelFormatter: (tool) => toolName[tool] || capitalize(tool),
            optional: true,
            width: 80,
            default: true
        },{
            title:"Job Name",
            dataIndex: "jobName",
            showFilter: true,
            render: (jobName) => CellRenderers.VALUE_OR_NA(jobName),
            optional: true,
            width: 100,
            default: true
        },{
            title: "Status",
            dataIndex: "status",
            width: 100,
            showFilter: true,
            filterLabelFormatter: capitalize,
            render: (text, original) => {
                text = capitalize(text)
                const onSelect = async () => {
                    ModalUtil.show({
                      content: (
                        <ReleasePopup
                          type=""
                          title={`Release build #${original.buildNumber}?`}
                          onOk={async ({note, acceptRisk, days}) => {
                            const unsupressAfterDuration = days ? moment().add(days, 'd').valueOf() : undefined
                            try {
                              await BuildAPI.putBuild({id: original.id, status: "RELEASE", note, acceptRisk, unsupressAfterDuration}).promise
                              this.refreshTable();
                              message.success("Build release successfully");
                            } catch (error) {
                              console.error(error);
                            }
                          }}
                        />
                      ),
                    });
                }
                return (text === "Hold" && hasPermission(PermissionSetMap.WRITE_TOOLS)) ? <Select
                                            options={[{key:"Release",value:"Release"}]} 
                                            onChange={onSelect} 
                                            value={text}    
                                            size="small"
                                            style={{ width: 90 }}
                                        /> : text
                }
        },{
            title:"Release Gate Status",
            dataIndex: "slaStatus",
            render: (value, record) => {
                if (record.slaStatus === "FAILED" && !_.isEmpty(record.failureReasonText)) {
                    return <>
                        {CellRenderers.SCAN_STATUS(value)}
                        <Tooltip title={record.failureReasonText}><InfoIcon /></Tooltip>
                    </>;
                }
                return CellRenderers.SCAN_STATUS(value);
            },
            showFilter: true,
            width: 120,
            filterLabelFormatter: CellRenderers.SCAN_STATUS,
            optional: true,
            default: true
        },{
            title:"Note",
            dataIndex: "note",
            render: CellRenderers.VALUE_OR_NA,
            optional: true,
            ellipsis: true,
            width: 70,
            default: true,
            showFilter: true,
            onlySearch: true
        },
        {
            title:"Execution Time",
            dataIndex: "createdAt",
            render: CellRenderers.TIME,
            width: 130,
            optional: true,
            default: true
        },{
            title:"Findings",
            dataIndex: "severity",
            width: FINDING_SEVERITY_BREAKDOWN_WIDTH,
            render: (severity, record) => {
                if(record.buildValidationType === "RISK_SCORE_BASED" && !isEmpty(record.otherProperties)){
                    return displayRiskRatingCountWithTooltip({riskRatingsSource: record.otherProperties, onClick: this.findingsRedirect, dataOnClick: record.findingIds}) 
                }
                return (
                    severity ? (
                        <ACFindingSeverityBreakDownBar
                            findingSeverity={severity}
                            activeSeverityKeys={CAPITALIZED_SEVERITIES}
                            redirectionFindings={(type) => this.findingsRedirect(lowerCase(type), record.findingIds, record.isRiskScoreBasedReleaseProcess)}
                            showTrend={false}
                        />
                    ) : CellRenderers.VALUE_OR_NA()
                )
            },
            optional: true,
            default: true
        }]
        return columns;
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    };

    getAllScan(params) {
        const {sortColumn, sortOrder} = params;
        // Generate queryparams object
        const obj = {
            ...params.filters,
            sort: sortColumn && sortOrder ? `${sortColumn},${sortOrder}` : undefined,
            ..._.omit(params, ["filters", "sort", "sortColumn", "sortOrder"])
        }
        return BuildAPI.getAll(obj);
    }
      
    getFilters() {
        const object = BuildAPI.getFilters()
        return object
    }
  
    render(){
        return <Card size="small" bodyStyle={{paddingBottom: 0}}>
                <TableContainerEvolved
                    title="Build History"
                    api={this.getAllScan}
                    columns={this.getCoulmns()}
                    filtersApi={this.getFilters}
                    enableScroll={true}
                    defaultFilter={{buildTool: [mapTool[this.props?.id]]}}
                    tableRef={tableRef => this.tableRef = tableRef}
                    defaultSort={{sortColumn: "createdAt", sortOrder: "descend"}}
                    locale={{ emptyText: "No configurations" }}
                />
            </Card>
    }
}

export default withRouter(JenkinsListing);

const mapTool = {
    Bamboo: "BAMBOO",
    Drone: "DRONE",
    Jenkins: "JENKINS",
    Azure_Pipeline: "AZURE_PIPELINE",
    GitHub_Actions: 'GITHUB_ACTIONS',
    Circle_CI :"CIRCLE_CI",
    Team_City :"TEAM_CITY",
    ReleaseIQ: "RELEASE_IQ",
    BuildKite: "BUILDKITE",
    GitLab_CI: "GITLAB_CI"
}

const toolName = {
    BAMBOO: "Bamboo",
    DRONE: "Drone",
    JENKINS: "Jenkins",
    AZURE_PIPELINE: "Azure Pipeline",
    GITHUB_ACTIONS: 'GitHub Actions',
    CIRCLE_CI: "Circle CI",
    TEAM_CITY: "Team City",
    RELEASE_IQ: "Release IQ",
    BUILDKITE: "BuildKite",
    GITLAB_CI: 'GitLab CI',
}
